/** Shared blur crossfade timing from WEB-717 (about-us WayCon showreel). */
export const BLUR_CROSSFADE_MS = 1200;
export const BLUR_CROSSFADE_BLUR_PX = 24;
export const BLUR_CROSSFADE_EASING = "cubic-bezier(0.45,0,0.15,1)";

export const BLUR_CROSSFADE_LAYER =
  "transition-[opacity,filter,transform] ease-[cubic-bezier(0.45,0,0.15,1)] motion-reduce:transition-none";

export const BLUR_CROSSFADE_HIDDEN = "scale-[1.03] opacity-0 blur-[24px]";

export const BLUR_CROSSFADE_VISIBLE = "scale-100 opacity-100 blur-none";

export function blurCrossfadeDurationStyle(
  instant: boolean,
  reducedMotion: boolean
): { transitionDuration: string } {
  if (instant || reducedMotion) {
    return { transitionDuration: "0ms" };
  }
  return { transitionDuration: `${BLUR_CROSSFADE_MS}ms` };
}
